import React from 'react';
import { SITE_IMAGES } from '../../components/siteImages';
export function FamilyTrainTogether() {
  return <section className="py-24 bg-paper border-b border-subtle-gray" data-id="element-1155">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1156">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-1157">
          <div data-id="element-1158">
            <div className="inline-flex items-center gap-2 bg-storm-red/10 text-storm-red px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-1159">
              On the Same Mat
            </div>
            <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1160">
              Train Together as a Family
            </h2>
            <p className="text-lg text-gray-warm mb-4" data-id="element-1161">
              Between school, work, and screens, time together can feel rare.
              Storm family classes give your family one positive activity -
              outside the house - where everyone is moving, learning, and
              cheering each other on.
            </p>
            <p className="text-lg text-gray-warm mb-4" data-id="element-1162">
              Parents and kids train side by side on the same mat. You earn
              belts together, work through challenges together, and walk out
              feeling closer than when you walked in.
            </p>
            <p className="text-lg text-gray-warm" data-id="element-1163">
              Storm instructors are friendly and experienced at teaching
              students of different ages at the same time. Every class is
              staffed with enough coaches so every family member gets real
              attention - not a one-size-fits-all workout.
            </p>
          </div>
          <div className="relative" data-id="element-1164">
            <img src={SITE_IMAGES.familyClasses} alt="Parent and child training together at Storm Taekwondo" className="block rounded-2xl shadow-xl w-full object-cover aspect-[4/3]" data-id="element-1165" />
            <div className="absolute -bottom-4 -left-4 bg-storm-red text-white px-5 py-3 rounded-2xl shadow-lg font-display uppercase tracking-wide text-sm" data-id="element-1166">
              Parents + Kids
            </div>
          </div>
        </div>
      </div>
    </section>;
}